import { Component, EventEmitter, Output } from "@angular/core";
import { UserSettingsCategory } from "@ponder-features/user/account/user-settings-category";

@Component({
    template: "",
    standalone: false
})
export class AccountEvents {
    @Output()
    public categorySelected: EventEmitter<UserSettingsCategory> = new EventEmitter();

    @Output()
    public paymentMethodRemovedEvent: EventEmitter<string> = new EventEmitter();
}